import { set, unset } from "../../js/lib/util";

export default (el: HTMLElement) => {
  const openSlideOut = (id: string) => {
    set(document.body, "showing-slide-out");
    const activeSlideOut = document.querySelector(
      `.js-slide-out.active`
    ) as HTMLElement;
    const slideOut = document.querySelector(
      `.js-slide-out[data-slide-out=${id}]`
    ) as HTMLElement;
    const slideOutFocus = document.querySelector(
      `.js-slide-out[data-slide-out=${id}] button, .js-slide-out[data-slide-out=${id}] a, .js-slide-out[data-slide-out=${id}] [role="button"]`
    ) as HTMLElement;
    activeSlideOut && unset(activeSlideOut, "active");
    set(slideOut, "active");
    slideOutFocus.focus();
  };

  const slideOutCTAs = Array.from(
    document.querySelectorAll(".js-slide-out-cta")
  );

  for (let cta of slideOutCTAs) {
    cta.addEventListener("click", () => {
      openSlideOut((cta as HTMLElement).dataset["slideOut"] as string);
    });
  }
};
